<template>
  <nav
    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar"> </navbar-toggle-button>
      <vue-bootstrap-typeahead
        slot="title-container"
        placeholder="Buscar"
        v-model="autocompletePadre"
        :data="selectedPadres"
      />

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <base-dropdown class="nav-item" menu-on-right tag="li" title-tag="a">
            <div class="dropdown-divider"></div>
            <a @click="cerrarSesion()" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Cerrar sesión</span>
            </a>
          </base-dropdown>
        </ul>
      </slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/dashboard">
                <img :src="logo" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button
                @click.native="closeSidebar"
              ></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>
        <!--Divider-->
        <hr class="my-3" />
        <!--Heading-->
      </div>
    </div>
  </nav>
</template>

<script>
import NavbarToggleButton from "@/components/NavbarToggleButton";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import axios from '@/directives/axios.js';
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  name: "sidebar",
  components: {
    VueBootstrapTypeahead,
    NavbarToggleButton,
  },
  data() {
    return {
      autocompletePadre: "",
      selectedPadres: ["jose", "antonio", "pedro", "luis"],
    };
  },
  props: {
    logo: {
      type: String,
      default: "favicon.png",
      description: "Sidebar app logo",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    cerrarSesion() {
      axios({
        method: "post",
        url: `/log-out`,
        withCredentials: true,
      })
        .then(() => {
          this.$cookies.remove("catecumen_token");
          this.$router.push({ name: "login" });
          swal.fire({
            title: `Sesión Cerrada Correctamente`,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          });
        })
        .catch(() => {});
    },
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
